import * as Validator from 'validatorjs';
// import * as yup from "yup";

Validator.useLang('fa');

Validator.register('mobile', function (val) {
    return val.match(/^09[0-9]{9}$/g);
}, 'شماره موبایل‌تون رو اشتباه وارد کردید.');

Validator.register('phone', function (val) {
    return (val.match(/^[1-9]{1}[0-9-]{6,7}$/g) || val.match(/^0[0-9-]{7,14}$/g) || val.match(/^[^0]{1}[0-9]{3}$/g));
}, 'شماره تلفن رو اشتباه وارد کردید.');

Validator.setMessages('fa', {
    required: ':attribute  رو وارد کنید.'
});

export default function Validation(data, rules) {
    return new Validator(data, rules);
}

/*
import * as yup from 'yup';

let schema = yup.object().shape({
    name: yup.string().required().min(3).max(64),
    last_name: yup.string().required().min(3).max(64),
    education: yup.string().nullable(),
    married: yup.string().nullable(),
    job: yup.string().nullable(),
    born_at: yup.string().nullable(),
});

const Options = {
    strict: false,
    abortEarly: false,
    stripUnknown: true,
    recursive: true,
};

schema.validate(fields, Options)
    .then(function (valid) {
        console.log(valid);
    })
    .catch(function (err) {
        console.log(err.errors)
    });*/
